import React from 'react';
import { ProtectedRoute, PublicRoute } from './RouteGuards';

// Public pages
import LandingPage from '../modules/public/pages/LandingPage';
import LoginPage from '../modules/public/pages/LoginPage';
import SignUpPage from '../modules/public/pages/SignUpPage';
import RulesPage from '../modules/public/pages/RulesPage';
import ForgotPasswordPage from '../modules/public/pages/ForgotPasswordPage';

// Strava
import StravaCallbackPage from '../modules/strava/pages/StravaCallbackPage';

// Protected pages
import FitHub from '../modules/dashboard/pages/FitHub';
import CompetitionPage from '../modules/competition/pages/CompetitionPage';
import CompetitionStatsPage from '../modules/competition/pages/StatisticsPage';
import CreateCompetitionPage from '../modules/competition/pages/CreateCompetitionPage';
import ProfilePage from '../modules/profile/pages/ProfilePage';
import FeedPage from '../modules/feed/pages/FeedPage';
import ActivityPage from '../modules/activity/pages/ActivityPage';
import CompetitionsOverview from '../modules/competition/pages/CompetitionsOverview';

const stravaEnabled = process.env.REACT_APP_FEATURE_STRAVA === 'true';

export const routes = [
    // Public Routes
    {
        path: '/',
        element: (
            <PublicRoute>
                <LandingPage />
            </PublicRoute>
        )
    },
    {
        path: '/login',
        element: (
            <PublicRoute>
                <LoginPage />
            </PublicRoute>
        )
    },
    {
        path: '/signup',
        element: (
            <PublicRoute>
                <SignUpPage />
            </PublicRoute>
        )
    },
    {
        path: '/rules',
        element: (
            <PublicRoute>
                <RulesPage />
            </PublicRoute>
        )
    },
    {
        path: '/forgot-password',
        element: (
            <PublicRoute>
                <ForgotPasswordPage />
            </PublicRoute>
        )
    },

    // Strava callback - public so ProtectedRoute doesn't redirect to /login and lose the code/state params
    ...(stravaEnabled ? [{
        path: '/strava/callback',
        element: (
            <PublicRoute>
                <StravaCallbackPage />
            </PublicRoute>
        )
    }] : []),

    // Protected Routes
    {
        path: '/fithub',
        element: (
            <ProtectedRoute>
                <FitHub />
            </ProtectedRoute>
        )
    },
    {
        path: '/competition/:id',
        element: (
            <ProtectedRoute>
                <CompetitionPage />
            </ProtectedRoute>
        )
    },
    {
        path: '/competitions',
        element: (
            <ProtectedRoute>
                <CompetitionsOverview />
            </ProtectedRoute>
        )
    },
    {
        path: '/competitions/create',
        element: (
            <ProtectedRoute>
                <CreateCompetitionPage />
            </ProtectedRoute>
        )
    },
    {
        path: '/competition/:id/stats',
        element: (
            <ProtectedRoute>
                <CompetitionStatsPage />
            </ProtectedRoute>
        )
    },
    {
        path: '/profile/:username',
        element: (
            <ProtectedRoute>
                <ProfilePage />
            </ProtectedRoute>
        )
    },
    {
        path: '/activities',
        element: (
            <ProtectedRoute>
                <FeedPage />
            </ProtectedRoute>
        )
    },
    {
        path: '/activities/:username',
        element: (
            <ProtectedRoute>
                <FeedPage />
            </ProtectedRoute>
        )
    },
    {
        path: '/activity/:id',
        element: (
            <ProtectedRoute>
                <ActivityPage />
            </ProtectedRoute>
        )
    },
    {
        path: '/activity',
        element: (
            <ProtectedRoute>
                <ActivityPage />
            </ProtectedRoute>
        )
    }
];